export default "__VITE_ASSET__202ae9f5__"